import type {SuggestObject} from '@yandex-delivery/api/model/suggest'
import {Box, Slot, Text, Typography} from '@yandex-delivery/blocks'
import {memo, useMemo} from 'react'

import * as classes from './SuggestItems.classes'

/** Пропсы компонента SuggestItems */
type SuggestItemsProps = {
  /** Коллбэк, вызываемый при выборе элемента из саджеста */
  onSelect: (address: SuggestObject) => void
  /** Адреса, показываемые в саджесте */
  items: SuggestObject[]
}

/**
 * Компонент со списком адресов для выбора.
 */
export const SuggestItems = memo<SuggestItemsProps>(function SuggestItems({onSelect, items}) {
  const selectHandlers = useMemo(() => items?.map(item => () => onSelect(item)) || [], [items, onSelect])

  if (items.length === 0) {
    return (
      <Box justifyContent="center" p="m">
        <Typography color="minor" variant="body2">
          Ничего не найдено
        </Typography>
      </Box>
    )
  }

  return (
    <>
      {items.map((item, index) => (
        <Slot
          key={`${item.id || item.uri || item.text}`}
          className={classes.slot}
          onClick={selectHandlers[index]}
          py="xs"
          size="l"
        >
          <Text>
            <Typography variant="body2">{item.title.text}</Typography>
            {item.subtitle && (
              <Typography color="minor" variant="caption1">
                {item.subtitle.text}
              </Typography>
            )}
          </Text>
          {item.distance && (
            <Typography className={classes.distance} color="minor" variant="caption1">
              {item.distance.text}
            </Typography>
          )}
        </Slot>
      ))}
    </>
  )
})
